var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 10 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.11163 4.07243H9.92331V0.917085C9.61075 0.874088 8.53581 0.777344 7.28393 0.777344C4.67183 0.777344 2.88248 2.42034 2.88248 5.44008V8.2192H0V11.7466H2.88248V20.6223H6.41654V11.7475H9.18243L9.6215 8.22003H6.41571V5.78985C6.41654 4.77032 6.69106 4.07243 8.11163 4.07243V4.07243Z",
    fill: "#1E2833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2c0034e16c0ea08a9588e178a6c989c9.svg";
export { ForwardRef as ReactComponent };